(() => {
  function validateData(values) {
    const errors = [];

    if (!values.UsrCliente) {
      errors.push({ fields: ["UsrCliente"], message: "El nombre de usuario es obligatorio." });
    }
    if (!values.UsrEmail && !values.UsrTelefono) {
      errors.push({ fields: ["UsrEmail", "UsrTelefono"], message: "Se requiere al menos un correo electrónico o número de teléfono." });
    }
    if (!values.UsrDNIperuId) {
      errors.push({ fields: ["UsrDNIperuId"], message: "El tipo de documento es obligatorio." });
    }
    if (!values.UsrDocumentoIdentidad) {
      errors.push({ fields: ["UsrDocumentoIdentidad"], message: "El número de documento es obligatorio." });
    }
    if (!values.UsrPerTiendaId) {
      errors.push({ fields: ["UsrPerTiendaId"], message: "El tienda es obligatorio." });
    }
    if (!values.UsrDetalleReclamoQuejaCliente) {
      errors.push({ fields: ["UsrDetalleReclamoQuejaCliente"], message: "Los detalles del reclamo son obligatorios." });
    }

    return errors;
  }

  function renderStatusBanner(data, type, errorFields) {
    form.querySelectorAll(".validation-error").forEach((el) => {
      el.classList.remove("validation-error");
    });

    const errorBlock = document.querySelector(".pqrs-form-submit-status-banner");

    if (!errorBlock) {
      return;
    }

    errorBlock.classList.remove("error", "success");
    errorBlock.innerHTML = "";

    if (!data) {
      return;
    }

    if (errorFields?.length) {
      const query = errorFields.map((f) => `[name="${f}"]`).join(",");
      form.querySelectorAll(query).forEach((el) => {
        el.classList.add("validation-error");
      });
    }

    const content = Array.isArray(data) ? data : [data];
    if (content.length === 1) {
      const p = document.createElement("p");
      p.textContent = content[0];
      errorBlock.appendChild(p);
    } else {
      const ul = document.createElement("ul");
      content.forEach((c) => {
        const li = document.createElement("li");
        li.textContent = c;
        ul.appendChild(li);
      });
      errorBlock.appendChild(ul);
    }

    if (type) {
      errorBlock.classList.add(type);
    }
  }

  const form = document.querySelector(".container__pqrs-form-v2 form.js-pqrs-form");

  form.addEventListener("change", (event) => {
    switch (event.target?.name) {
      case "UsrEsMenorDeEdadTxt":
        if (event.target.checked) {
          jQuery(".js-under-age-section").slideDown(250);
        } else {
          jQuery(".js-under-age-section").slideUp(250);
        }

        break;

      case "UsrPerTiendaId":
        const selectedLocation = mcStoresData.find((l) => l.id === event.target.value);

        if (selectedLocation?.address) {
          form.querySelector(".js-store-address").textContent = selectedLocation.address;
        }

        break;
    }
  });

  let isSubmitting = false;
  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    isSubmitting = true;

    const submitButton = form.querySelector("button[type=submit]");
    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());
    const errors = validateData(values);

    renderStatusBanner();
    submitButton && submitButton.classList.add("loading");

    if (errors?.length) {
      const errorFields = [...new Set(errors.map((e) => e.fields).flat())];
      renderStatusBanner("Error al enviar al formulario.", "error", errorFields);
      submitButton && submitButton.classList.remove("loading");
      return;
    }

    const isUnderAge = values?.UsrEsMenorDeEdadTxt?.toLowerCase() === "on";
    const data = {
      UsrIDSERV: "PER",
      UsrFechaIngresoPQR: new Date().toISOString(),
      UsrPerTiendaId: values.UsrPerTiendaId,
      UsrPerProvinciaId: values.UsrPerProvinciaId,

      UsrCliente: values.UsrCliente,
      UsrDNIperuId: values.UsrDNIperuId,
      UsrDocumentoIdentidad: values.UsrDocumentoIdentidad,
      UsrEsMenorDeEdadTxt: isUnderAge ? "SI" : "NO",
      UsrTelefono: values.UsrTelefono,
      UsrEmail: values.UsrEmail,
      UsrDireccion: values.UsrDireccion,

      UsrNombrereplegalper: isUnderAge ? values.UsrNombrereplegalper : undefined,
      Usraddrreplegper: isUnderAge ? values.Usraddrreplegper : undefined,
      Usrtelefonoreplegal: isUnderAge ? values.Usrtelefonoreplegal : undefined,
      Usremailreplegper: isUnderAge ? values.Usremailreplegper : undefined,

      UsrTipoeclamoPERId: values.UsrTipoeclamoPERId,
      UsrBienContratadoTxt: values.UsrBienContratadoTxt,
      UsrDescripcionBienContratado: values.UsrDescripcionBienContratado,
      UsrPedidoDelCliente: values.UsrPedidoDelCliente,
      UsrDetalleReclamoQuejaCliente: values.UsrDetalleReclamoQuejaCliente,
      UsrDatereclamo: values.UsrDatereclamo ? new Date(values.UsrDatereclamo).toISOString() : undefined,
      UsrImontodeclarado: Number(values.UsrImontodeclarado),
      UsrObservacionesreclamoperu: values.UsrObservacionesreclamoperu,
      UsrveracityTitleBoolean: values.UsrveracityTitleBoolean === "on",
    };
    console.log(data, "data");
    

    try {
      const request = await fetch("https://lsmpvo2wchbvwp247elvfizore0vlrtz.lambda-url.us-east-2.on.aws/creatio/Case", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "API-Version": "2.0",
        },
        body: JSON.stringify(data),
      });
      if (request.status && request.status >= 400) {
        throw new Error("Failed to send request.");
      }


      renderStatusBanner("Estimado cliente, pronto recibirá la respuesta a su solicitud en el correo registrado.", "success");
      form.reset();
    } catch (err) {
      console.error(err);
      renderStatusBanner("Error al enviar el formulario.", "error");
    } finally {
      submitButton && submitButton.classList.remove("loading");
      isSubmitting = false;
    }
  });
})();
